/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-04-30 12:12:40
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-05-27 16:04:01
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelCategory/slice/constants.ts
 */
export enum EnumReducers {
  products = 'products',
  legal = 'legal',
  content = 'content',
}
